var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFollowerVine4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 569,
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#065e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#328e72"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2048") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    display: "inline"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m57.89,19.03c15.49,-3.52 55.63,-5.63 75.35,8.45c19.72,14.08 23.94,38.03 14.08,49.3c-9.86,11.27 -44.37,28.17 -53.52,52.11c-9.15,23.94 12.68,69.72 8.45,108.45c-4.23,38.73 -22.54,83.8 -33.1,123.94c-10.56,40.14 4.93,92.25 35.21,109.86c30.28,17.61 86.62,8.45 107.04,-14.79c20.42,-23.24 -6.34,-61.27 -5.63,-89.44c0.7,-28.17 23.94,-54.23 7.04,-73.24c-16.9,-19.01 -38.73,-6.34 -65.49,-26.76c-26.76,-20.42 -33.1,-71.83 -23.94,-102.11c9.15,-30.28 16.2,-56.34 44.37,-83.8c28.17,-27.46 50,-41.55 73.24,-44.37c23.24,-2.82 50,-5.63 60.56,26.06c10.56,31.69 4.23,97.18 -6.34,130.99c-10.56,33.8 -28.17,74.65 -30.28,97.18c-2.11,22.54 5.63,52.82 14.08,70.42c8.45,17.61 27.46,58.45 33.1,88.03c5.63,29.58 5.63,68.31 -15.49,89.44c-21.13,21.13 -65.49,28.17 -85.21,18.31c-19.72,-9.86 -21.83,-27.46 -50,-33.1c-28.17,-5.63 -40.14,14.79 -64.79,27.46c-24.65,12.68 -63.38,2.11 -76.76,-17.61c-13.38,-19.72 -6.34,-47.18 4.93,-67.61c11.27,-20.42 21.13,-57.04 19.72,-89.44c-1.41,-32.39 -16.2,-76.76 -25.35,-96.48c-9.15,-19.72 -15.49,-54.23 -12.68,-97.18c2.82,-42.96 33.1,-42.25 35.92,-73.24c2.82,-30.99 -23.94,-30.99 -21.13,-55.63c2.82,-24.65 21.13,-31.69 36.62,-35.21z",
    fill: "#ff0000",
    fillOpacity: 0.01,
    id: "svg_21",
    stroke: "#f90000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFollowerVine4);
export default __webpack_public_path__ + "static/media/mobileFollowerVine4.77132e1a5d76030f483aee78e7208f7e.svg";
export { ForwardRef as ReactComponent };